/* ==========================================================================
   duvelle-pdp.js
   Comportements de la page produit Duvelle (Silouvelle).
   Un custom element <duvelle-size-guide> et un unique ecouteur delegue.
   Aucun texte destine aux clientes n'est ecrit ici : toutes les chaines
   proviennent de reglages Liquid, ce qui les rend traduisibles via
   Translate & Adapt.
   ========================================================================== */
(function () {
  'use strict';

  var FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function normalize(value) {
    return String(value == null ? '' : value)
      .toUpperCase()
      .replace(/\s+/g, '');
  }

  if (!window.customElements.get('duvelle-size-guide')) {
    window.customElements.define(
      'duvelle-size-guide',
      class extends HTMLElement {
        constructor() {
          super();
          this.selection = { band: null, cup: null, fit: null };
          this.lastTrigger = null;
          this.onKeydown = this.onKeydown.bind(this);
          this.onBackdrop = this.onBackdrop.bind(this);
        }

        connectedCallback() {
          this.dialog = this.querySelector('[data-dv-dialog]');
          this.resultEl = this.querySelector('[data-dv-result]');
          this.resultSizeEl = this.querySelector('[data-dv-result-size]');
          this.helpEl = this.querySelector('[data-dv-result-help]');
          this.noMatchEl = this.querySelector('[data-dv-result-nomatch]');
          this.rows = this.parseRows();

          if (this.bound) return;
          this.bound = true;

          var self = this;
          this.addEventListener('click', this.onBackdrop);

          this.querySelectorAll('[data-dv-close]').forEach(function (button) {
            button.addEventListener('click', function () {
              self.close();
            });
          });

          this.querySelectorAll('[data-dv-chip]').forEach(function (chip) {
            chip.addEventListener('click', function () {
              var group = chip.getAttribute('data-dv-group');
              var scope = chip.closest('[data-dv-chips]');
              if (scope) {
                scope.querySelectorAll('[data-dv-chip]').forEach(function (other) {
                  other.setAttribute('aria-pressed', 'false');
                });
              }
              chip.setAttribute('aria-pressed', 'true');
              self.selection[group] = chip.getAttribute('data-dv-value');
              self.compute();
            });
          });
        }

        parseRows() {
          var raw = this.getAttribute('data-dv-rows');
          if (!raw) return [];
          try {
            var parsed = JSON.parse(raw);
            return Array.isArray(parsed) ? parsed : [];
          } catch (error) {
            return [];
          }
        }

        /* Le resultat derive uniquement des correspondances saisies par le
           marchand dans les blocs "ligne du guide" : aucun calcul arbitraire. */
        compute() {
          if (!this.selection.band || !this.selection.cup) return;

          var token = normalize(this.selection.band + this.selection.cup);
          var index = -1;

          for (var i = 0; i < this.rows.length; i++) {
            var matches = this.rows[i].matches || [];
            for (var j = 0; j < matches.length; j++) {
              if (normalize(matches[j]) === token) {
                index = i;
                break;
              }
            }
            if (index > -1) break;
          }

          if (index === -1) {
            this.showResult(null);
            return;
          }

          var relaxedLabel = this.getAttribute('data-dv-relaxed-label') || '';
          var sizeUp = this.getAttribute('data-dv-size-up-relaxed') === 'true';
          if (
            sizeUp &&
            this.selection.fit &&
            relaxedLabel &&
            normalize(this.selection.fit) === normalize(relaxedLabel)
          ) {
            index = Math.min(index + 1, this.rows.length - 1);
          }

          this.showResult(this.rows[index].size);
        }

        showResult(size) {
          if (!this.resultEl) return;
          var matched = Boolean(size);

          if (this.resultSizeEl) this.resultSizeEl.textContent = matched ? size : '—';
          if (this.helpEl) this.helpEl.hidden = !matched;
          if (this.noMatchEl) this.noMatchEl.hidden = matched;

          this.resultEl.hidden = false;
        }

        open(trigger) {
          this.lastTrigger = trigger || null;
          this.classList.add('is-open');
          this.setAttribute('data-open', 'true');
          document.documentElement.style.overflow = 'hidden';
          document.addEventListener('keydown', this.onKeydown);

          var target = this.dialog ? this.dialog.querySelector(FOCUSABLE) : null;
          if (target) {
            target.focus();
          } else if (this.dialog) {
            this.dialog.setAttribute('tabindex', '-1');
            this.dialog.focus();
          }
        }

        close() {
          this.classList.remove('is-open');
          this.removeAttribute('data-open');
          document.documentElement.style.overflow = '';
          document.removeEventListener('keydown', this.onKeydown);
          if (this.lastTrigger && document.contains(this.lastTrigger)) {
            this.lastTrigger.focus();
          }
        }

        onBackdrop(event) {
          if (event.target === this) this.close();
        }

        onKeydown(event) {
          if (event.key === 'Escape') {
            event.stopPropagation();
            this.close();
            return;
          }
          if (event.key !== 'Tab' || !this.dialog) return;

          var nodes = Array.prototype.slice
            .call(this.dialog.querySelectorAll(FOCUSABLE))
            .filter(function (node) {
              return node.offsetParent !== null;
            });
          if (!nodes.length) return;

          var first = nodes[0];
          var last = nodes[nodes.length - 1];

          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        }

        disconnectedCallback() {
          document.removeEventListener('keydown', this.onKeydown);
          document.documentElement.style.overflow = '';
        }
      }
    );
  }

  /* Un seul ecouteur delegue, pose une fois : il survit aux rechargements de
     sections dans l'editeur de theme et n'est jamais duplique. */
  if (!window.__duvellePdpDelegated) {
    window.__duvellePdpDelegated = true;

    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      var trigger = target.closest('[data-dv-size-guide-open]');
      if (!trigger) return;
      var guide = document.querySelector('duvelle-size-guide');
      if (!guide || typeof guide.open !== 'function') return;
      event.preventDefault();
      guide.open(trigger);
    });
  }
})();
